import { render, staticRenderFns } from "./boxStyle.vue?vue&type=template&id=29ce1ea0&scoped=true"
import script from "./boxStyle.vue?vue&type=script&lang=js"
export * from "./boxStyle.vue?vue&type=script&lang=js"
import style0 from "./boxStyle.vue?vue&type=style&index=0&id=29ce1ea0&prod&lang=scss&scoped=true"
import style1 from "./boxStyle.vue?vue&type=style&index=1&id=29ce1ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce1ea0",
  null
  
)

export default component.exports